import { render } from "./form.vue?vue&type=template&id=de5b129c&scoped=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=de5b129c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-de5b129c"

export default script